export const COMBO_MILESTONES: readonly number[] = [5, 10, 25, 50, 100, 200] as const;

export function crossedMilestone(prevStreak: number, newStreak: number): number | null {
  if (newStreak <= prevStreak) return null;
  for (const milestone of COMBO_MILESTONES) {
    if (prevStreak < milestone && newStreak >= milestone) return milestone;
  }
  return null;
}
